import { render, staticRenderFns } from "./TodoTask.vue?vue&type=template&id=5f567dea&scoped=true&"
import script from "./TodoTask.vue?vue&type=script&lang=js&"
export * from "./TodoTask.vue?vue&type=script&lang=js&"
import style0 from "./TodoTask.vue?vue&type=style&index=0&id=5f567dea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f567dea",
  null
  
)

export default component.exports